var styleDataHash = "7767d8d7";
const injectCss = () => {
  var css = `.HjKs9{height:18px;position:relative;width:18px}._5fmDZ,.znRxp{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] ._5fmDZ,[dir=ltr] .znRxp{left:0}[dir=rtl] ._5fmDZ,[dir=rtl] .znRxp{right:0}.znRxp{stroke:currentColor;opacity:.3}[dir=ltr] .znRxp{animation:tAHiw 666ms linear infinite}[dir=rtl] .znRxp{animation:F9d4K 666ms linear infinite}._5fmDZ{stroke:currentColor}[dir=ltr] ._5fmDZ{animation:tAHiw 2s linear infinite}[dir=rtl] ._5fmDZ{animation:F9d4K 2s linear infinite}@keyframes tAHiw{to{transform:rotate(1turn)}}@keyframes F9d4K{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "HjKs9",
  "top": "znRxp",
  "bottom": "_5fmDZ",
  "rotation-ltr": "tAHiw",
  "rotation-rtl": "F9d4K"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
